<template>
  <v-container>
    <v-row>
      <v-col class="display-1" cols="12">
        Bug Reports and Feature Requests
      </v-col>
      <v-col cols="12">
        Please use the Google Form below to submit your feedback. If the form isn't loading or looks wrong here, you can <a href="https://forms.gle/f1PacP94dBTHMAqV7" target="_blank">go to the form directly</a>. If you've got a problem with Google (I understand), feel free to email me directly. My email address is on <a href="https://vinneycavallo.com/" target="_blank">my personal site</a>.
      </v-col>
      <v-col cols="12">
        Before you send a request, though, please take a look at the list below. I'm keeping a running punchlist of the features I plan to add in the (near-ish) future as well as known-bugs that I will fix when I can. If you see your feature/bug in the list below, maybe reconsider sending the feedback, but feel free to nag me about it on Discord or elsewhere :) A little sadistic nudging goes a long way to motivate me.
      </v-col>
      <v-col>
        <v-btn v-if="!showForm" @click="showForm = true" color="primary">Show feedback Form</v-btn>
        <div v-if="showForm">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeYdeHasMzXmyoZ6VwaXvo5-uTkCjzF4SZj5yUZsDAXnEDMEg/viewform?embedded=true" width="640" height="800" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="display-1" cols="12">
        Known Issues and Pending Features
      </v-col>
      <v-col cols="12">
        <span class="headline">Bugs/missing things and smaller changes:</span>
        <ul>
          <li>Experience checkboxes weird on smaller screens</li>
          <li>Debilities not present yet!</li>
          <li>Momentum icon in footer doesn't "burn" correctly when clicked</li>
          <li>Log momentum burns</li>
          <li>Add assets!</li>
          <li>Add 'Your Truths' section? (or just let the user use the general notes area for this?)</li>
          <li>Categorize moves</li>
          <li>Categorize oracles</li>
          <li>Support progress rolls</li>
          <li>Allow Exporting Log and all character details</li>
          <li>Make the oracles popup better</li>
          <li>Some of the moves are missing. They will be added</li>
          <li>Support markdown in any text-area fields</li>
          <li>Delve moves will be added</li>
          <li>Delve oracles will be added</li>
          <li>Delve themes/domains will be added</li>
          <li><span class="text--disabled">DONE Make it easier/faster to get to a move and roll it</span></li>
          <li><span class="text--disabled">DONE Add character name</span></li>
          <li><span class="text--disabled">DONE Experience Track not present yet! Hah! How did I miss that?!</span></li>
          <li><span class="text--disabled">DONE Add Bonds track!</span></li>
          <li><span class="text--disabled">DONE Fix cAsE in some move titles</span></li>
          <li><span class="text--disabled">DONE Add a basic notes area</span></li>
          <li><span class="text--disabled">DONE Oracle was only rolling 1-10.... oops. fixed.</span></li>
        </ul>
      </v-col>
      <v-col cols="12">
        <span class="headline">Future bigger features:</span>
        <ul>
          <li>Sharing a session to other devices (without dealing with accounts and logins)</li>
          <li>Allow for adding arbitrary additional + or - to Move Rolls</li>
          <li>Add Threats to progress tracks</li>
          <li>General 'Notes' area <strong>with ability to add arbitrary separate notes entries and organize by title</strong></li>
          <li>Ironlands map with pin-dropping and labeling</li>
          <li>"Analog Companion Mode" - strictly moves and oracles plus reference items (like Assets). Each roll would prompt you for any modifiers and simply display a result. No character sheet or tracks of any kind. With the freed-up real estate it would be easier to make the moves and oracles very easily accessible. Ideally you could have just a notebook and this app open in this mode and you'd need nothing else.</li>
          <li>Keyboard shortcuts for everything on desktop</li>
        </ul>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      showForm: false,
    }
  }
}
</script>
